import type { Module } from 'vuex';
import { ActionError } from '@/types/ActionError';
import {RootState} from "@/store";

export interface ActionErrorState {
  actionError: ActionError | null;
  deleted: boolean;
}

const actionErrorModule: Module<ActionErrorState, RootState> = {
  namespaced: true,

  state: (): ActionErrorState => ({
    actionError: null,
    deleted: false,
  }),

  mutations: {
    setActionError(state, payload: any) {
      if (payload === null || payload === undefined) {
        state.actionError = null;
        state.deleted = false;
        return;
      }
      state.actionError = ActionError.fromRaw(payload);
      state.deleted = false;
    },

    setActionErrorDelete(state, payload: { idActionError: number }) {
      if (state.actionError?.idActionError === payload.idActionError) {
        state.deleted = true;
      }
    },

    clearActionError(state) {
      state.actionError = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetActionError({ commit }, payload) {
      commit('setActionError', payload);
    },

    wsSetEmptyActionError({ commit }) {
      commit('setActionError', null);
    },

    wsActionErrorDelete({ commit }, payload) {
      commit('setActionErrorDelete', payload);
    },

    clearActionError({ commit }) {
      commit('clearActionError');
    },
  },
};

export default actionErrorModule;
